import { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark, faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { toast } from 'react-hot-toast';
import { formatCurrency} from '../utils/currencyUtils';
import Modal from 'react-modal';
import Select from "react-select";

function RowList7({data}) {
    const [modalIsOpen, setIsOpen] = useState(false);
    const [showMenu, setShowMenu] = useState(false);
    const [duration, setDuration] = useState(data.duration);
    const [roi, setRoi] = useState(data.roi);
    const [roi_usd, setRoi_usd] = useState(data.roi_usd);
    const [amount, setAmount] = useState(data.amount);
    const [status, setStatus] = useState(data.status);
    const [loading, setLoading] = useState(false);
    const [disable, setDisable] = useState(true);
    const menuRef = useRef();
    useEffect(() => {
        if(duration && amount && roi && status ){
            setDisable(false);
        }else{
            setDisable(true);
        }
    }, [duration, amount, roi, status]);
    useEffect(() => {
        function handleClickOutside(event) {
        if (menuRef.current && !menuRef.current.contains(event.target)) {
            setShowMenu(false);
        }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    const Delete = () => {
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
            credentials: "include",
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ deleteStake: true, id: data.id })
        })
          .then(response => response.json())
          .then(data => {
            if (data.status === "success") {
              toast.success(data.result);
              window.location.reload();
            }else{
              toast.error(data.message);
            }
          })
          .catch(err => {
            console.error(err)
        })
    }
    const Cancel = () => {
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
            credentials: "include",
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ cancelStake: true, id: data.id })
        })
          .then(response => response.json())
          .then(data => {
            if (data.status === "success") {
              toast.success(data.result);
              window.location.reload();
            }else{
              toast.error(data.message);
            }
          })
          .catch(err => {
            console.error(err)
        })
    }
    const End = () => {
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
            credentials: "include",
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ endStake: true, id: data.id })
        })
          .then(response => response.json())
          .then(data => {
            if (data.status === "success") {
              toast.success(data.result);
              window.location.reload();
            }else{
              toast.error(data.message);
            }
          })
          .catch(err => {
            console.error(err)
        })
    }
    const Manage = () => {
        setLoading(true);
        fetch(`${process.env.REACT_APP_API_URL}controller/manage.controller.php`, {
            credentials: "include",
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ setStake: true, id: data.id, duration:duration, amount:amount, roi:roi, roi_usd:roi_usd, status:status })
        })
          .then(response => response.json())
          .then(data => {
            if (data.status === "success") {
              toast.success(data.result);
                window.location.reload();
            }else{
              toast.error(data.message);
            }
            setLoading(false);
          })
          .catch(err => {
            console.error(err);
            setLoading(false);
        })
    }
    const statusoptions = [
        { value: 1, label: "Open" },
        { value: 0, label: "Closed" }
    ];
    const darkThemeStyles = {
        control: (styles) => ({
          ...styles,
          backgroundColor: "#151719",
          border: "none",
          color: "#fff",
          minWidth: "135px"
        }),
        menu: (styles) => ({
          ...styles,
          backgroundColor: "#151719",
        }),
        option: (styles, { isFocused, isSelected }) => ({
          ...styles,
          backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
          color: "#fff",
        }),
        singleValue: (styles) => ({
          ...styles,
          color: "#fff",
        }),
    };

    return (
        <>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={() => setIsOpen(false)}
          shouldCloseOnOverlayClick={true} 
          closeTimeoutMS={100}
          className="shortmode"
        >
            <div className="d-flex align-items-center justify-content-between">
                <p className="mb-0 fw-bold text-white" style={{fontSize: '15px'}}>Manage staking</p>
                <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen(false)} />
            </div>
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Staked Amount:</label>
            <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1`}>
                <input 
                    type="text" 
                    placeholder="0.00 " 
                    className="inputNone"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                />
                <div className="fw-bold text-white d-flex align-items-center" style={{backgroundColor: 'rgb(30, 33, 36)', borderRadius:'4px',padding: '6px',fontSize: '14px', cursor: 'pointer'}}>
                <img src={data.logo} alt="Method" style={{width: '20px'}} className="me-1" /> {data.symbol}
                </div>
            </div>
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>ROI:</label>
            <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1`}>
                <input 
                    type="text" 
                    placeholder="0.00" 
                    className="inputNone"
                    value={roi}
                    onChange={(e) => setRoi(e.target.value)}
                />
                <div className="fw-bold text-white d-flex align-items-center" style={{backgroundColor: 'rgb(30, 33, 36)', borderRadius:'4px',padding: '6px',fontSize: '14px', cursor: 'pointer'}}>
                <img src={data.logo} alt="Method" style={{width: '20px'}} className="me-1" /> {data.symbol}
                </div>
            </div>
            {/* <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>ROI USD:</label>
            <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1`}>
                <input 
                    type="text" 
                    placeholder="1000" 
                    className="inputNone"
                    value={roi_usd}
                    onChange={(e) => setRoi_usd(e.target.value)}
                />
                <div className="fw-bold text-white d-flex align-items-center" style={{backgroundColor: 'rgb(30, 33, 36)', borderRadius:'4px',padding: '6px',fontSize: '14px', cursor: 'pointer'}}>
                <img src={`/uploads/usd.svg`} alt="Method" style={{width: '20px'}} className="me-1" /> USD
                </div>
            </div> */}
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Duration:</label>
            <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1`}>
                <input 
                    type="text" 
                    placeholder="10" 
                    className="inputNone"
                    value={duration}
                    onChange={(e) => setDuration(e.target.value)}
                />
                <div className="fw-bold text-white d-flex align-items-center" style={{backgroundColor: 'rgb(30, 33, 36)', borderRadius:'4px',padding: '6px',fontSize: '14px', cursor: 'pointer'}}>Days</div>
            </div>
            <label className="fw-semibold mb-1" style={{fontSize: '14px'}}>Status:</label>
            <Select 
                options={statusoptions} 
                value={statusoptions.find((opt) => opt.value === status)}
                onChange={(e) => setStatus(e.value)}
                styles={darkThemeStyles}
                className="w-full"
            />
            <div className={`myBtn w-100 text-center mt-3 ${disable?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={() => {if (!disable) {Manage();}
            }}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:`Save`}</div>
        </Modal>
        <tr className="fw-semibold">
            <td>#{data.id}</td>
            <td>
                <div className='d-flex align-items-center'>
                    <div className='d-flex align-items-center justify-content-center rounded-2 text-prime fw-semibold' style={{backgroundColor:'#ffffff0d', width: '32px', height: '32px'}}>
                        <span>{data?.user?.fullname.charAt(0)}</span>
                    </div>
                    <span className='ms-2 text-nowrap'>{data?.user?.fullname}</span>
                </div>
            </td>
            <td className='text-nowrap fw-bold'><img src={data.logo} alt="Method" style={{width: '20px'}} /> {formatCurrency(data.amount)} {data.symbol}</td>
            <td className='text-nowrap fw-bold'>{data.duration} days</td>
            <td className='text-nowrap fw-bold'><img src={data.logo} alt="Method" style={{width: '20px'}} /> {formatCurrency(data.roi)} {data.symbol}</td>
            {/* <td className='text-nowrap fw-bold'>{formatCurrency(data.roi_usd)} USD</td> */}
            <td className='text-nowrap fw-bold'>{data.date}</td>
            <td className={`${data.status == '1' ? 'text-success' : 'text-danger'}`}>{data.status == '1' ? 'Open' : 'Closed'}</td>
            <td style={{ position: "relative" }}>
                <div
                className="myBtn d-inline-block px-3"
                style={{ cursor: "pointer" }}
                onClick={() => setShowMenu((prev) => !prev)}
                >
                Edit
                </div>
                {showMenu && (
                <div
                    ref={menuRef}
                    className="dropdown-menu-custom"
                    style={{
                    position: "absolute",
                    top: "35px",
                    right: 0,
                    background: "#232528",
                    borderRadius: "8px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                    zIndex: 10,
                    minWidth: "120px",
                    padding: "5px",
                    }}
                >
                    <div className="dropdown-item px-3 py-2 rounded-3" style={{ color: "#fff", cursor: "pointer" }} onClick={() => Cancel()}>
                    Cancel
                    </div>
                    <div className="dropdown-item px-3 py-2 rounded-3" style={{ color: "#fff", cursor: "pointer" }} onClick={() => End(true)}>
                    End (with ROI)
                    </div>
                    <div className="dropdown-item px-3 py-2 rounded-3" style={{ color: "#fff", cursor: "pointer" }} onClick={() => setIsOpen(true)}>
                    Manage
                    </div>
                    <div className="dropdown-item px-3 py-2 rounded-3" style={{ color: "#fff", cursor: "pointer" }} onClick={() => Delete()}>
                    Delete
                    </div>
                </div>
                )}
            </td>
        </tr>
        </>
    )
  }
  
  export default RowList7